<template lang="pug">
    .component-reveal-void
        reveal(:confirm="true", @confirm="refundTransaction")
            a.button.alert(v-if="buttons", slot="trigger") Refund
            a(v-else, slot="trigger") Refund
            h2 Do you really want to refund the transaction
                strong TR{{transaction.id}}
            .row
                .medium-6.columns
                    label
                        | Amount
                        input(type='number', v-model="refundFields.amount")
</template>
<script type="text/babel">
    import Reveal from "../../Reveal";
    export default{
        name: "TransactionRevealRefund",
        components: {Reveal},
        data(){
            return {}
        },
        created() {
        },
        methods: {
            refundTransaction(){
                this.$emit('refundTransaction')
            }
        },
        computed: {},
        props: ['buttons', 'transaction', 'refundFields'],
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// TransactionRevealRefund.vue?1e0e8291